var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "dashboard-page-title" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("h1", [_vm._v("Endorsements")]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "btn btn-info",
            attrs: { "active-class": "" },
            on: {
              click: function ($event) {
                return _vm.$router.go(-1)
              },
            },
          },
          [
            _c("i", { staticClass: "fa fa-chevron-left" }),
            _vm._v(" Back\n      "),
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            directives: [
              {
                name: "scroll-to",
                rawName: "v-scroll-to",
                value: "#bottom",
                expression: "'#bottom'",
              },
            ],
            staticClass: "btn btn-primary",
            attrs: { disabled: _vm.haveUnsavedEndorsement },
            on: { click: _vm.handleAddNewEndorsementCallback },
          },
          [_c("i", { staticClass: "fa fa-plus" }), _vm._v(" Add New")]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "dashboard-block" }, [
        _c(
          "ul",
          { staticClass: "item-detail" },
          [
            _vm._l(_vm.endorsements, function (endorsement, index) {
              return _c("profile-talent-endorsements-list-item", {
                key: endorsement.id,
                attrs: { index: index, endorsement: endorsement },
              })
            }),
            _vm._v(" "),
            _vm.haveNoEndorsements
              ? _c("li", { staticClass: "text-center" }, [
                  _vm._v("\n          There are no endorsements.\n        "),
                ])
              : _vm._e(),
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { attrs: { id: "bottom" } }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }